import { render, staticRenderFns } from "./HotKeywords.vue?vue&type=template&id=bda8812e&scoped=true"
import script from "./HotKeywords.vue?vue&type=script&lang=js"
export * from "./HotKeywords.vue?vue&type=script&lang=js"
import style0 from "./HotKeywords.vue?vue&type=style&index=0&id=bda8812e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda8812e",
  null
  
)

export default component.exports